var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconBookends = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_62672_3621)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M19.3249 14.6857L12.7749 4.64405C12.5166 4.25239 12.0416 4.07739 11.5916 4.21072C11.1416 4.34405 10.8333 4.75239 10.8333 5.21905V15.2691C10.8333 15.8524 11.3083 16.3274 11.8916 16.3274H18.4416C18.8249 16.3274 19.1833 16.1191 19.3666 15.7774C19.5499 15.4357 19.5333 15.0191 19.3249 14.6941V14.6857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.89352 4.21072C7.44352 4.07739 6.96852 4.25239 6.71019 4.64405L0.168522 14.6941C-0.0398109 15.0191 -0.0564776 15.4357 0.126856 15.7774C0.310189 16.1191 0.668522 16.3274 1.05186 16.3274H7.60186C8.18519 16.3274 8.66019 15.8524 8.66019 15.2691V5.22739C8.66019 4.76072 8.36019 4.35239 7.90186 4.21905L7.89352 4.21072Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_62672_3621"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconBookends);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-bookends.ec3f0268cdb86ef0571ca8d970b3c823.svg";